export const BeyondDesignSystemRouterPath = 'beyond-design-system';
